module.exports = {
  platform: 'voice',
  name: 'Checkpoint',
  node: 'checkpoint',
  bg: '#FFFFFF',
  note: ''
}
